
import { defineComponent, Ref } from "vue";

export default defineComponent({
  emits: ["removeProduto"],
  props: ["title", "products", "okHeader"],
});
